import { useEffect } from "react";
import config from "../config/config";
import { Client } from "../interfaces/clientConfig";

const { REACT_APP_CLIENT_NAME: clientEnv } = config;

const getClientConfig = (client?: Client | undefined) => {
  switch (client) {
  case "bna":
    return {
      title: "Tienda BNA",
      favicon: "/favicon-bna.ico",
    };
  case "macro":
    return {
      title: "Tienda Macro",
      favicon: "/favicon-macro.ico",
    };
  default:
    return {
      title: "Coatí",
      favicon: "/favicon.ico",
    };
  }
};

export const useClientConfig = () => {
  const { title, favicon } = getClientConfig(clientEnv);
  useEffect(() => {
    document.title = title;

    const link: HTMLLinkElement =
			document.querySelector("link[rel~='icon']") ||
			document.createElement("link");

    link.rel = "icon";
    link.href = favicon;

    document.head.appendChild(link);
  }, []);
};
